export default "__VITE_ASSET__DBfl1zCf__"